const actions = {
  SET_STATE: 'subscriptions/SET_STATE',
  FETCH_ALL_SUBSCRIPTIONS: 'subscriptions/FETCH_ALL_SUBSCRIPTIONS',
  FETCH_SUBSCRIPTION_DETAILS: 'subscriptions/FETCH_SUBSCRIPTION_DETAILS',
  FETCH_SUBSCRIPTION_PAYMENTS: 'subscriptions/FETCH_SUBSCRIPTION_PAYMENTS',
  UPDATE_SUBSCRIPTION: 'subscriptions/UPDATE_SUBSCRIPTION',
  CANCEL_SUBSCRIPTION: 'subscriptions/CANCEL_SUBSCRIPTION',
}

export default actions
